// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScenarioCashFlowPortfolioOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProposalWhereInput>;
}>;


export type GetScenarioCashFlowPortfolioOptionsQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: { __typename?: 'Proposal', id: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string, outOfEstatePortfolios?: Array<{ __typename?: 'GiftingProposalPortfolio', id: string, displayName: string }> | null } | null } | null } | null> | null } };

export const Operations = {
  Query: {
    GetScenarioCashFlowPortfolioOptions: 'GetScenarioCashFlowPortfolioOptions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetScenarioCashFlowPortfolioOptionsDocument = gql`
    query GetScenarioCashFlowPortfolioOptions($where: ProposalWhereInput) {
  proposals(where: $where) {
    edges {
      node {
        id
        giftingProposal {
          id
          outOfEstatePortfolios {
            id
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetScenarioCashFlowPortfolioOptionsQuery__
 *
 * To run a query within a React component, call `useGetScenarioCashFlowPortfolioOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioCashFlowPortfolioOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioCashFlowPortfolioOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetScenarioCashFlowPortfolioOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>(GetScenarioCashFlowPortfolioOptionsDocument, withFetchPolicyContext(options));
      }
export function useGetScenarioCashFlowPortfolioOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>(GetScenarioCashFlowPortfolioOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetScenarioCashFlowPortfolioOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>(GetScenarioCashFlowPortfolioOptionsDocument, withFetchPolicyContext(options));
        }
export type GetScenarioCashFlowPortfolioOptionsQueryHookResult = ReturnType<typeof useGetScenarioCashFlowPortfolioOptionsQuery>;
export type GetScenarioCashFlowPortfolioOptionsLazyQueryHookResult = ReturnType<typeof useGetScenarioCashFlowPortfolioOptionsLazyQuery>;
export type GetScenarioCashFlowPortfolioOptionsSuspenseQueryHookResult = ReturnType<typeof useGetScenarioCashFlowPortfolioOptionsSuspenseQuery>;
export type GetScenarioCashFlowPortfolioOptionsQueryResult = Apollo.QueryResult<GetScenarioCashFlowPortfolioOptionsQuery, GetScenarioCashFlowPortfolioOptionsQueryVariables>;